import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5 from '@amcharts/amcharts5';
import { DomSanitizer } from '@angular/platform-browser';
import * as am5percent from '@amcharts/amcharts5/percent';
import { SharedService } from '../shared.service';
interface ChartData {
  title: string;
  value1: number;
  value2: number;
  color: string;
}
@Component({
  selector: 'stc-apps-multi-circles-chart',
  standalone: false,
  templateUrl: './multi-circles-chart.component.html',
  styleUrl: './multi-circles-chart.component.scss',
})
export class MultiCirclesChartComponent implements OnChanges, OnDestroy , AfterViewInit{
  // chartdiv_id = '';
  // chartDivId:any;
  chartDivId: any;
  chartdiv_id = "";
  chartData!: ChartData[];
  root: am5.Root | null = null;
  @Input({ required: true }) chartData2: ChartData[] = [];
  // @Input() chartData2:any;
  maxWidth = 100;
  constructor(
    public dom_s: DomSanitizer,
    private financialService: SharedService
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.root) {
      this.root.dispose();
      this.root = null;
    }
    if (
      this.chartData2 &&
      this.chartData2.length !== 0
    ) {
      // this.root = am5.Root.new('multiCircleChart');
      this.solidGaugeChart();
    }
  }
  ngAfterViewInit(): void {
    if (this.root) {
      this.root.dispose();
      this.root = null;
    }
    if (
      this.chartData2 &&
      this.chartData2.length !== 0
    ) {
      this.solidGaugeChart();
    }
  }
  ngOnDestroy(): void {
    if (this.root) {
      this.root.dispose();
    }
  }
  solidGaugeChart() {
    // this.root = am5.Root.new(this.chartdiv_id);
    if(document.getElementById("multiCircleChart"))
    {
      this.root = am5.Root.new('multiCircleChart');
    }
    this.root?.setThemes([am5themes_Animated.new(this.root)]);
    if (this.root) {
      const chart = this.root?.container.children.push(
        am5percent.PieChart.new(this.root, {
          layout: this.root.verticalLayout,
          innerRadius: am5.percent(30),
        })
      );
      if (this.root._logo) {
        this.root._logo.dispose();
      }
      const series0 = chart?.series.push(
        am5percent.PieSeries.new(this.root, {
          valueField: 'litres',
          categoryField: 'country',
          alignLabels: false,
        })
      );
      const bgColor = this.root?.interfaceColors.get('background');
      series0.ticks.template.setAll({ forceHidden: true });
      series0.labels.template.setAll({ forceHidden: true });
      series0.slices.template.setAll({
        stroke: bgColor,
        strokeWidth: 2,
        tooltipText: '{category}:{value}',
      });
      series0.slices.template.states.create('hover', { scale: 0.95 });
      const series1 = chart.series.push(
        am5percent.PieSeries.new(this.root, {
          valueField: 'bottles',
          categoryField: 'country',
          alignLabels: true,
        })
      );
      series1.slices.template.setAll({
        stroke: bgColor,
        strokeWidth: 2,
        // fill : am5.color("#000"),
        // tooltipText:"{category}: {valuePercentTotal.formatNumber('0.00')}% ({value} litres)",
        tooltipText: '{category}:{value}',
      });
      const series2 = chart.series.push(
        am5percent.PieSeries.new(this.root, {
          valueField: 'test1',
          categoryField: 'country',
          alignLabels: true,
        })
      );
      series2.slices.template.setAll({
        stroke: bgColor,
        strokeWidth: 2,
        tooltipText: '{category}:{value}',
      });
      const series3 = chart.series.push(
        am5percent.PieSeries.new(this.root, {
          valueField: 'test2',
          categoryField: 'country',
          alignLabels: true,
        })
      );
      this.root.numberFormatter.set("numberFormat", "#.#a");
      series3.slices.template.setAll({
        stroke: bgColor,
        strokeWidth: 2,
        tooltipText: '{category}:{value}',
      });
      const colors = ['#B999D1', '#61CBD6', '#00C48C', '#4F008C', '#000'];
      series0.set(
        'colors',
        am5.ColorSet.new(this.root, {
          colors: [am5.color(colors[0]), am5.color('#F1F1F1')],
          passOptions: {}, // Optional: Customize gradient behavior
        })
      );
      series1.set(
        'colors',
        am5.ColorSet.new(this.root, {
          colors: [am5.color(colors[1]), am5.color('#F1F1F1')],
          passOptions: {}, // Optional: Customize gradient behavior
        })
      );
      series2.set(
        'colors',
        am5.ColorSet.new(this.root, {
          colors: [am5.color(colors[2]), am5.color('#F1F1F1')],
          passOptions: {}, // Optional: Customize gradient behavior
        })
      );
      series3.set(
        'colors',
        am5.ColorSet.new(this.root, {
          colors: [am5.color(colors[3]), am5.color('#F1F1F1')],
          passOptions: {}, // Optional: Customize gradient behavior
        })
      );
      series0.labels.template.set('forceHidden', true);
      series1.labels.template.set('forceHidden', true);
      series2.labels.template.set('forceHidden', true);
      series3.labels.template.set('forceHidden', true);
      series0.ticks.template.set('forceHidden', true);
      series1.ticks.template.set('forceHidden', true);
      series2.ticks.template.set('forceHidden', true);
      series3.ticks.template.set('forceHidden', true);
      const legend = chart.children.push(
        am5.Legend.new(this.root, {
          nameField: 'name',
          centerX: am5.percent(50),
          x: am5.percent(55),
          layout: this.root.gridLayout,
          fillField: "color",
          strokeField: "color",
          // layout: this.root.horizontalLayout,
          tooltip: am5.Tooltip.new(this.root, {}),
        })
      );
      legend.labels.template.setAll({
        fill: am5.color('#616161'),
        fontWeight: '600',
        oversizedBehavior: 'truncate',
        maxWidth: 40,
      });
      // Add tooltip to each legend item
      legend.itemContainers.template.set('tooltipText', '{name}');
      const tooltipColors: am5.Color[] = [];
      this.chartData2.forEach((d) => {
        tooltipColors.push(am5.color(d.color));
      });
      legend.itemContainers.template.adapters.add(
        'tooltip',
        (tooltip, target, key) => {
          const index = legend.dataItems.indexOf(
            target.dataItem as am5.DataItem<any>
          );
          // const labelWidth = target?.children?.getIndex(0)?.width();
          // if (labelWidth && labelWidth > 100)
          // {
          legend
            .get('tooltip')
            ?.get('background')
            ?.setAll({
              fill: tooltipColors[index % tooltipColors.length],
              fillOpacity: 1,
              strokeWidth: 0,
            });
          // } else {
          //   legend.get("tooltip")?.set("forceHidden" , true);
          // }

          return tooltip;
        }
      );
      // For more advanced tooltips, use a function to access custom properties
      legend.itemContainers.template.setAll({
        paddingBottom: 10, // Reduces the vertical space between items
        paddingTop: 0,
        paddingRight: 0, // Adjust to reduce horizontal space between legend items
        paddingLeft: 0,
        marginRight: 0, // Additional option to control horizontal space
        marginLeft: 0,
      });
      legend.markers.template.setAll({
        width: 15,
        height: 15,
      });
      legend.markerRectangles.template.setAll({
        cornerRadiusTL: 10,
        cornerRadiusTR: 10,
        cornerRadiusBL: 10,
        cornerRadiusBR: 10,
      });
      // console.log(this.chartData2);
      const newArr:any = []
      this.chartData2.forEach(d => {
        newArr.push({
          name: d.title,
          color: d.color
        })
      })
      legend.data.setAll(newArr);
      const data = [
        {
          country: 'Accural',
          litres: this.chartData2[0] && this.chartData2[0].value2 ? this.chartData2[0].value2 : null,
          bottles: this.chartData2[1] && this.chartData2[1].value2 ? this.chartData2[1].value2 : null,
          test1: this.chartData2[2] && this.chartData2[2].value2 ? this.chartData2[2].value2 : null,
          test2: this.chartData2[3] && this.chartData2[3].value2 ? this.chartData2[3].value2 : null,
        },
        {
          country: 'Spending',
          litres: this.chartData2[0] && this.chartData2[0].value1 ? this.chartData2[0].value1 : null,
          bottles: this.chartData2[1] && this.chartData2[1].value1 ? this.chartData2[1].value1 : null,
          test1: this.chartData2[2] && this.chartData2[2].value1 ? this.chartData2[2].value1 : null,
          test2: this.chartData2[3] && this.chartData2[3].value1 ? this.chartData2[3].value1 : null,
        },
      ];
      // console.log(newArr);
      // console.log(data);
      series0.data.setAll(data);
      series1.data.setAll(data);
      series2.data.setAll(data);
      series3.data.setAll(data);
      series0.appear(1000, 100);
      series1.appear(1000, 100);
      series2.appear(1000, 100);
      series3.appear(1000, 100);
    }
  }
}
